import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateFormMapping } from "../services/update-form-mapping";
import { UpdateFormMappingRequest } from "@/pages/forms/types/form";
import { toast } from "@/hooks/use-toast";

export function useUpdateFormMapping(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateFormMappingRequest) => updateFormMapping(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["form", id] });
      queryClient.invalidateQueries({ queryKey: ["forms"] });
      toast({ title: "Saved", description: "Field mapping updated" });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description:
          error.response?.data?.message || "Failed to update field mapping",
        variant: "destructive",
      });
    },
  });
}
